import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5a1de74a&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=tsx&"
export * from "./detail.vue?vue&type=script&lang=tsx&"
import style0 from "./detail.vue?vue&type=style&index=0&id=5a1de74a&lang=less&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1de74a",
  null
  
)

export default component.exports